import { PartialWindow } from '../services';
import { createEmptyFunctionMock } from '../test-utils/jest';

export class PartialWindowMock implements PartialWindow {
  readonly location = {
    href: 'http://cairo.test',
  };

  readonly matchMedia: PartialWindow['matchMedia'] = (query) => ({
    matches: false,
    media: query,
    onchange: null,
    addListener: () => {},
    removeListener: () => {},
    addEventListener: () => {},
    removeEventListener: () => {},
    dispatchEvent: () => true,
  });

  download = createEmptyFunctionMock();
  close = createEmptyFunctionMock();
}
